import { Box, Grid, styled, useTheme } from "@mui/material";
import React, { useContext, useEffect, useState } from "react";
import SideBar from "../../components/SideBar";
import ProgressTitle from "./progressTitle";
import ProgressOutcomes from "./progressOutcomes";
import ProgressInfluences from "./progressInfluences";
import RatingGraph from "./ratingGraph";
import { makeStyles } from "@material-ui/core";
import { ReportsTypeContext } from "../../context/userIReports";
import { UserTypeContext } from "../../context/userStatus";
import { reportsService } from "../../services/reportsService";
import {
  setReportWeekData,
  setReportWeekDataTotalCount,
} from "../../store/actions/reportTypeAction";
import FullpageLoader from "../../components/fullPageLoader";
import ProgressTitleDetails from "./progressTitleDetails";
import ReportDetails from "./ReportDetails";
import TrackHeader from "../tracker/TrackHeader";
import { useNavigate } from "react-router-dom";
import { ContactsContext } from "../../context/userIContacts";

const RootStyle = styled("div")(({ theme }) => ({
  padding: "0px!important",
  overflowX: "hidden",
  overflowY: "auto",
  [theme.breakpoints.down("lg")]: {
    padding: "40px 20px 0px",
  },
  [theme.breakpoints.down(1001)]: {
    padding: "20px",
  },
}));

const useStyles = makeStyles((theme) => ({
  progressInfluence: {
    [theme.breakpoints.down(1001)]: {
      maxWidth: "100%!important",
    },
  },
  ratingGraph: {
    [theme.breakpoints.down(1001)]: {
      maxWidth: "100%!important",
      marginTop: "48px!important",
    },
  },
}));

const ProgressWeek = () => {
  const { state: IUserTypeState, dispatch: userTypeDispatch } =
    useContext(UserTypeContext);
  const { state: IContactTypeState, dispatch: contactsDispatch } =
    useContext(ContactsContext);
  const { state: IReportTypeContext, dispatch: reportTypeDispatch } =
    useContext(ReportsTypeContext);
  const isDarkMode = useTheme().palette.mode === "dark" || IUserTypeState.isDarkMode
  const [showLoader, setShowLoader] = useState(false);
  const navigate = useNavigate();
  useEffect(() => {
    getUserWeekReport(IReportTypeContext.currentPage);
  }, [IReportTypeContext.isWeekReport, IReportTypeContext.currentPage]);
  const getUserWeekReport = (page) => {
    setShowLoader(true);
    const userId = {
      page,
    };
    reportsService
      .getAllWeeks(userId, IUserTypeState.token)
      .then((data: any) => {
        reportTypeDispatch(setReportWeekData(data?.data));
        reportTypeDispatch(setReportWeekDataTotalCount(data?.total));
      })
      .catch((error) => {
        console.log("User profile Error");
      })
      .finally(() => {
        setShowLoader(false);
      });
  };
  const classes = useStyles();
  const [isExpandMode, setIsExpandMode] = useState(
    localStorage.getItem("isExpandMode") === "true"
  );
  console.log();

  return (
    <Grid
      container
      columns={16}
      height={"100vh"}
      className="tracking_container"
    >
      {showLoader && <FullpageLoader />}
      <Grid
        item
        sx={{ borderRight: "1px solid " + (isDarkMode ? "var(--dark-border-color)" : "#DCE6E0") }}
        // xs={isExpandMode ? 0.73 : 2.04}
        width={isExpandMode ? "90px" : "220px"}
        position={"relative"}
      >
        <SideBar
          isExpandMode={isExpandMode}
          setIsExpandMode={setIsExpandMode}
        />
      </Grid>

      <Grid item /* xs={isExpandMode ? 15.27 : 13.96} */ sx={{
        width: isExpandMode ?  "calc(100vw - 90px)"  :  "calc(100vw - 220px)"
      }}>
        <RootStyle>
          <Box sx={{
            padding: "0px 0px 16px",
            borderBottom: "1px solid " + (isDarkMode ? "var(--dark-border-color)" : "#EEEEEE")
          }}>
            <TrackHeader
              setIsArchiveMode={(val) => {
                if (val) {
                  navigate("/tracking", {
                    state: {
                      direct: true,
                    },
                  });
                }
              }}
            />
          </Box>

          {Object.keys(IReportTypeContext.selectedRow).length && window.location.pathname.includes("progress/weekly") && !IContactTypeState.shareModalOpen ? (
            <Box
              sx={{
                background: Object.keys(IReportTypeContext.selectedRow).length
                  ? "transparent"
                  : isDarkMode ? "var(--white-background)" : "#fff",
                margin: "32px",
                padding: "0!important",
                height: "calc(100vh - 150px) !important",
                overflowY: "auto",
                overflowX: "hidden"
              }}
              className="hide-scrollbar"
            >
              <ProgressTitleDetails setShowLoader={setShowLoader} isDarkMode={isDarkMode}/>
              <ReportDetails isDarkMode={isDarkMode}/>
            </Box>
          ) : (
            <Box
              sx={{
                background: Object.keys(IReportTypeContext.selectedRow).length
                  ? "transparent"
                  : isDarkMode ? "var(--white-background)" : "#fff",
                margin: "32px",
                padding: "24px",
                borderRadius: "20px 20px 0px 0px",
              }}
            >
              <ProgressTitle isDarkMode={isDarkMode}/>
              <ProgressOutcomes isDarkMode={isDarkMode}/>
            </Box>
          )}
        </RootStyle>
      </Grid>
    </Grid>
  );
};

export default ProgressWeek;
